import { PartialBlock } from "@blocknote/core";
import { makeAutoObservable } from "mobx";
type editorContentType = PartialBlock[] | null;
export class RTEStore {
  editors: Record<string, PartialBlock[]> = {};
  editorsMarkDown: Record<string, string> = {};
  constructor() {
    makeAutoObservable(this);
  }
  setEditorValues = (name: string, content: PartialBlock[]) => {
    this.editors[name] = content;
  };

  getEditors = (name: string) => {
    return this.editors?.[name];
  };
  setEditorMarkDownValues = (name: string, content: string) => {
    this.editorsMarkDown[name] = content;
  };
  getEditorMarkDown = (name: string): string => {
    return this.editorsMarkDown?.[name] || "";
  };
}
